/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { Button, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import { tableColumns } from './handlers'

const TableHeader = ({ columns }) => (
  <Thead>
    <Tr>
      { columns.map(column => (
        <Th key={column.id}>
          { column.title }
        </Th>
      ))}
      <Th></Th>
    </Tr>
  </Thead>
)

const UserResourcePermissionsTable = ({
  items,
  onEditPermission
}) => {
  const columnsIds = tableColumns
    .map(column => column.title && column.id)
    .filter(Boolean)
  const rows = items.map(item => {
    const isActive = item.status === 'ACTIVE'
    const buttonLabel = isActive
      ? 'Revoke permission'
      : 'Activate permission'
    const editType = isActive
      ? 'revoke'
      : 'activate'
    return (
      <Tr key={item.id}>
        {columnsIds.map((key, index) => (
          <Td key={index}>{ item[key] }</Td>
        ))}
        <Td>
          <Button
            onClick={() => onEditPermission(editType, item.id)}
            colorScheme={ isActive && 'red'}
          >
            { buttonLabel }
          </Button>
        </Td>
      </Tr>
    )
  })

  return (
    <Table variant="simple">
      <TableHeader
        columns={tableColumns}
      />
      <Tbody>
        { rows }
      </Tbody>
    </Table>
  )
}

export default UserResourcePermissionsTable
